/*
 * contact-uae translations for the "ar" locale.
 *
 * Split out of locales/ar.js so this feature's copy stops shipping to
 * every route in the app. See locales/contact-uae/index.js.
 */
export default {
    banner: {
      title: (
        <>
          <h1>تمويل من غير حدود مع كونتكت!</h1>
          <br />
          <h2>اشتري في مصر، وقسط من الإمارات </h2>
        </>
      ),
      description: (
        <>
          <p>
            كونتكت بتقدم أفضل خدمة في مجال التمويل الاستهلاكي في مصر؛ من خلال
            تقديم حلول مبتكرة بتساعد عملائنا يشتروا دلوقتي ويدفعوا بعدين مع
            مزايا وخطط دفع مرنة، قدرنا نساعد عدد كبير من المصريين على تحقيق
            أحلامهم وإدارة مشترياتهم ومصاريفهم بشكل أحسن. على مدار 25 سنة،
            كونتكت بتستمر في وضع معايير جديدة للتميز والابتكار في مجال التمويل
            في مصر.
          </p>
          <>
            دلوقتي بنوسع خدماتنا علشان يستفيد منها المصريين اللي عايشين أو
            بيشتغلوا في الإمارات العربية المتحدة. مع كونتكت تقدر تشتري أي حاجة
            في مصر وتدفع من الإمارات بكل سهولة، سواء كان اللي انت محتاجه خدمة
            تمويل أو تأمين. استمتع بالراحة والمرونة في إدارة احتياجاتك المالية
            مع دعم متواصل من كونتكت.
          </>
        </>
      ),
    },
    second_section: {
      title: "احنا بنموّل كل اللي ممكن تحتاجه!",
      description:
        "كونتكت بتقدم مجموعة واسعة من خدمات التمويل والتأمين لتغطية كل احتياجاتك في مصر، ومنها:",
      list: [
        { name: "تمويل السيارات", url: "/products/auto" },
        { name: "تمويل الدراجات النارية", url: "/products/motorcycles" },
        { name: "تمويل النقل", url: "/products/trucks" },
        { name: "تمويل عقاري", url: "/products/mortgage" },
        { name: "تمويل التصميم والتشطيب", url: "/products/home-interior" },
        { name: "تمويل فرش البيت", url: "/products/home-furniture" },
        { name: "التمويل الأخضر", url: "/products/green-finance" },
        { name: "تمويل الصيانة", url: "/products/maintainance" },
        { name: "مناسك", url: "/products/travel-and-tourism" },
        { name: "تمويل اشتراكات الأندية", url: "/products/clubs" },
        { name: "تمويل التعليم", url: "/products/education" },
        { name: "التسوق", url: "/products/contact-now" },
        { name: "خدمات التأمين", url: "/products/insurance" },
        {
          name: "تمويل مركبات ومعدات الرياضات المائيه",
          url: "/products/watercraft",
        },
      ],
    },
    third_section: {
      title: "كونتكت جنبك في الإمارات!",
      description:
        "في كونتكت، إحنا فاهمين احتياجات المصريين المقيمين في الإمارات وملتزمين بتوفير خدمات مالية وتأمينية متميزة ليهم. هدفنا هو جعل إدارة مصاريفك واحتياجاتك التمويلية مريحة وبلا ضغوط، سواء كنت في مصر أو الإمارات. بنقدم لك:",
      list: [
        "حلول تمويل وتأمين متنوعة: استمتع بنفس مجموعة الخدمات المتاحة في السوق المصري.",
        "خدمة متكاملة من بيتك: مش محتاج تسافر لمصر. تقدر تقدم على منتجات التمويل أو التأمين من راحة بيتك في الإمارات.",
        "خدمه سريعه وسهله: استفد من الإجراءات السهلة والسريعة بأقل قدر من المتطلبات.",
        "خيارات دفع مرنة: وزع تكلفة مشترياتك مع خطط الدفع المرنة من كونتكت.",
        "خدمة عملاء على مدار الساعة: فريقنا من الخبراء ملتزمين بتقديم دعم احترافي خلال رحلتك التمويلية والتأمينية، سواء كنت في مصر أو الإمارات.",
      ],
    },
    form: {
      title: "إزاي تقدم؟",
      subTitle1: "سجل بياناتك وسيتصل بك أحد ممثلينا",
      subTitle2: "قدم دلوقتي واستمتع بتجربة جديدة من الحلول المالية مع كونتكت!",
      name: "الاسم بالكامل",
      email: "البريد الإلكتروني",
      national_id: "الرقم القومي",
      phone_number: "رقم الهاتف",
      product: "المنتج",
      product_list_name: "اختر المنتج",
      product_list: [
        { id: 1, product_name: "تمويل السيارات", value: "auto" },
        { id: 2, product_name: "تمويل النقل", value: "trucks" },
        { id: 3, product_name: "تسوق", value: "shopping" },
        { id: 4, product_name: "تمويل التعليم", value: "education" },
        { id: 5, product_name: "تمويل اشتراكات الاندية", value: "clubs" },
        { id: 6, product_name: "تمويل الصيانة", value: "maintenance" },
        { id: 7, product_name: "تمويل الدراجات النارية", value: "21" },
        { id: 9, product_name: "تمويل عقاري", value: "mortgage" },
        { id: 10, product_name: "التمويل الأخضر", value: "greenFinance" },
        { id: 11, product_name: "تمويل فرش البيت", value: "19" },
        {
          id: 12,
          product_name: "تمويل التصميم و التشطيب",
          value: "homes",
        },
        {
          id: 13,
          product_name: "تمويل مركبات ومعدات الرياضات المائية",
          value: "20",
        },
        { id: 14, product_name: "مناسك", value: "manasik" },
        { id: 15, product_name: "وساطة تأمينية", value: "brokerage" },
      ],
      message: "رسالتك",
      submit: "ارسال",
    },
    last_section: {
      contact_us: "تواصل معنا",
      list: [
        {
          title: "التليفون",
          description: "اتصل بنا للحصول على المساعدة الفورية",
          info: (
            <>
              <>
                <a
                  dir="ltr"
                  href="tel:+971 54 700 4400"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    marginBottom: "10px",
                    display: "block",
                  }}
                >
                  +971 54 700 4400
                </a>
                <a
                  dir="ltr"
                  href="tel:+971 50 865 3388"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  +971 50 865 3388
                </a>
              </>
            </>
          ),
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/phone-icon-uae.png",
        },
        {
          title: "الايميل",
          description:
            "إرسال الاستفسارات عبر البريد الإلكتروني للحصول على الدعم",
          info: "Info@contact.eg",
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/email-icon-uae.png",
        },
        {
          title: "الموقع",
          description: "تفضل بزيارة فرعنا في الإمارات",
          info: (
            <a
              target="_blank"
              href="https://maps.app.goo.gl/wPXEt4zWJrxrgC3p6?g_st=awb"
              style={{ textDecoration: "underline", color: "inherit" }}
            >
              مكتب تاماناي آرتس بمنطقة الخليج التجاري - مكتب 1806 
            </a>
          ),
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/location-icon-uae.png",
        },
      ],
    },
  };
